export const ImageWidth = 4.375;
